import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import { withStyles } from "@material-ui/core/styles"
import MuiAccordion from "@material-ui/core/Accordion"
import MuiAccordionSummary from "@material-ui/core/AccordionSummary"
import MuiAccordionDetails from "@material-ui/core/AccordionDetails"
import Typography from "@material-ui/core/Typography"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import { TiTick } from "@react-icons/all-files/ti/TiTick"
import ReactPlayer from "react-player"
import CourseSection from "./CourseSection"

import styled from "styled-components"
import { useSelector } from "react-redux"

const Accordion = withStyles({
  root: {
    // borderBottom: "1.5px solid rgba(21, 21, 21, 0.22) !important",
    // background: "#c7d0d8",

    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion)

const AccordionSummary = withStyles({
  root: {
    marginBottom: -1,
    minHeight: 56,
    "&$expanded": {
      minHeight: 56,
    },
  },
  content: {
    "&$expanded": {
      margin: "12px 0",
    },
  },
  expanded: {},
})(MuiAccordionSummary)

const AccordionDetails = withStyles(() => ({
  root: {
    padding: 0,
  },
}))(MuiAccordionDetails)
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    // background: "rgb(248, 248, 248, 0.4)",
    // boxShadow: "0px 5px 5px rgba(0, 0, 0, 0.19)",
    borderRadius: "5px",
    // overflowX: "hidden",
    // overflowY: "auto",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}))

function CourseContentAccordion(props) {
  const {
    data,

    keyId,
    uri,
    category,
    orderKey,
    title,
  } = props

  const [, updateState] = React.useState()
  const topic = useSelector((state) => state.user.topic)
  const details = useSelector((state) => state.user.details)

  // get first module
  const firstModule = topic[keyId]?.moduleId || 0

  //sections length
  const sectionLength = (dId) => {
    let sectionTotal = 0

    for (let i = 0; i < dId.length; i++) {
      sectionTotal += dId[i].sections.length
      console.log(dId[i].length)
    }

    return sectionTotal
  }


  const courseLength = data.modules.reduce((prev, curr) => {
    curr.course_sections?.forEach((c) => {
      c.sections.map((a) => prev.push(a.title))
    })
    return prev
  }, [])

  //get module length
  const moduleLength = (dId) =>
    Object.keys(details).filter(
      (key) => details[key].module_ids === dId && details[key].checked === true
    ).length

  //end of get module length

  const [expanded, setExpanded] = React.useState(
    data.modules[firstModule]?.module_title
  )
  const classes = useStyles()

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false)
  }

  return (
    <Wrapper>
      <div className={classes.root}>
        <div className="content_heading">
          <h4>Contents</h4>
        </div>
        {data.modules &&
          data.modules.map((d, i) => {
            return (
              <Accordion
                square
                expanded={expanded === `${d.module_title}`}
                onChange={handleChange(`${d.module_title}`)}
                key={i}
              >
                <AccordionSummary1
                  aria-controls="panel2d-content"
                  id="panel2d-header"
                  expandIcon={<ExpandMoreIcon />}
                  equalLength={
                    (moduleLength(d.id) / sectionLength(d.course_sections)) *
                    100
                  }
                >
                  <div
                    style={{ display: "flex", flexDirection: "column" }}
                    className="accordion_title"
                  >
                    <Typography key={d.id} className="module_title">
                      {d.module_title}
                    </Typography>
                    <span style={{ fontSize: "0.8rem" }}>
                      {moduleLength(d.id)} / {sectionLength(d.course_sections)}{" "}
                      | {d.module_estimation_time_for_completion}
                    </span>
                  </div>
                </AccordionSummary1>
                <AccordionDetails>
                  <CourseSection
                    data={d.course_sections}
                    uri={uri}
                    category={category}
                    module_id={i}
                    keyId={keyId}
                    module_title={d.module_title}
                    short_dec={data.short_description || data.overview}
                    slug={data.slug}
                    course_image={data.course_image}
                    mainModule_id={d.id}
                    orderKey={orderKey}
                    courseLength={courseLength}
                    title={title}
                  />
                </AccordionDetails>
              </Accordion>
            )
          })}
        {/* <div>
        {details?.map((s) => s.map((l) => <span>{l[0].id}</span>))}
      </div> */}
      </div>
    </Wrapper>
  )
}

export default CourseContentAccordion

const Wrapper = styled.div`
  width: 100%;
  height: auto;
  .MuiAccordionSummary-root {
    background-color: #c7d0d8;
  }
  .MuiAccordionDetails-root {
    padding: 0;
  }
  .module_title {
    font-weight: 700 !important;
    text-transform: capitalize;
    @media (max-width: 767px) {
      font-size: 1rem !important;
    }
  }
`

const AccordionSummary1 = styled(AccordionSummary)`
  &:before {
    content: "";
    background-color: #00203f40;
    width: ${(props) => `${props.equalLength}%`};
    position: absolute;
    height: 100%;
    left: 0;
  }
`
